// dataFetcher.js
import { md5 } from "./md5";
import dataDefault from "./data";

export class DataFetcher {
    constructor() {
      this.baseUrl = 'https://m.p4psearch.1688.com/hamlet/async/v1.json';
    }
  
    // 构建请求参数
    buildRequestParams(keyword, beginpage) {
      const timeStamp = Date.now();
      const salt = `${timeStamp}${Math.floor(Math.random() * 10)}`;
      const signOrigin = `pcsem${keyword}${salt}csb44T%34CiKj&FyRbCBJ`;
    
      const requestParams = {
        beginpage,
        sign: md5(signOrigin),
        salt,
        position: 'wx_list_async_request',
        keyword,
        hmaTid: 3,
        hmaQuery: 'graphDataQuery',
        api: 'wxSearch',
        count: 20,
        pidClass: 'wx_list_750',
        cpx: 'cpc,free,nature',
      };

  
      return requestParams;
    }
  
    // 构建请求 URL
    buildRequestUrl(params) {
      const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');
      

      const adReqUrl = this.baseUrl + '?scene=WuxianOfferResult' + this.convertArrToStr(params);
      return adReqUrl;
    }

    convertArrToStr(obj) {
      return Object.keys(obj).reduce((total, key) => {
        total = total + '&' + key + '=' + obj[key];
        return total;
      }, '');
    }
  
  
    // 获取数据
    async fetchData(keyword, beginpage) {
      try {
        console.log(keyword)

        const requestParams = this.buildRequestParams(keyword, beginpage);
        console.log(requestParams);
        const url = this.buildRequestUrl(requestParams);
        console.log(url);
  
        const response = await fetch(url, {
          credentials: 'include',
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
  
        const data = await response.json();
        return {
          success: true,
          data: data?.module?.offer?.list || [],
        };
      } catch (error) {
        console.error('Error fetching data:', error);
        return {
          success: false,
          error: error.message,
          data: dataDefault,
        };
      }
    }

  }
